import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, TextField, Typography, Alert, Paper } from "@mui/material";
import { login as loginApi, setAuthToken } from "../api/agentApi";
import { useTenantBranding } from "../context/TenantBrandingContext";

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { branding, resolveBrandAssetUrl } = useTenantBranding();
  const logoUrl = resolveBrandAssetUrl(branding.logoUrl);

  const handleSubmit = async e => {
    e.preventDefault();
    setError("");
    if (!username.trim() || !password) {
      setError("Username and password are required");
      return;
    }
    setLoading(true);
    try {
      const result = await loginApi(username.trim(), password);
      if (result.access_token) {
        setAuthToken(result.access_token);
        // Pass token and full response (including password_set_by_operator flag)
        onLogin(result.access_token, result);
        navigate("/dashboard");
      } else {
        setError("Invalid credentials");
      }
    } catch (err) {
      setError("Login failed: " + (err.message || "Unknown error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component={Paper} elevation={3} sx={{ maxWidth: 400, mx: "auto", my: 8, p: 4 }}>
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 2 }}>
        {logoUrl ? (
          <img
            src={logoUrl}
            alt={`${branding.brandName} logo`}
            style={{ height: 128, maxWidth: "100%", objectFit: "contain" }}
          />
        ) : (
          <Typography variant="h4" sx={{ fontWeight: 900, textAlign: "center" }}>
            {branding.brandName}
          </Typography>
        )}
        {branding.showPoweredByNextMoca && (
          <Typography
            variant="caption"
            sx={{ mt: 1, color: "text.secondary", fontWeight: 700 }}
          >
            powered by Next Moca
          </Typography>
        )}
      </Box>
      <Typography variant="h4" component="h1" gutterBottom>Login</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Enter your name"
          value={username}
          onChange={e => setUsername(e.target.value)}
          fullWidth
          margin="normal"
          autoFocus
        />
        <TextField
          label="Password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          fullWidth
          margin="normal"
        />
        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }} disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </Button>
      </form>
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
    </Box>
  );
}
